export function inheritsFrom(Type, ParentType) {
  while (Type) {
    if (Type === ParentType) {
      return true;
    }

    Type = Object.getPrototypeOf(Type);
  }

  return false;
}
//# sourceMappingURL=inherits-from.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@deck.gl/react/dist/esm/utils/inherits-from.js
// module id = 720
// module chunks = 0